export const CONTENT_TABLE_HEADER_DISPLAY_NAMES = {
  CONTENT_SCORE: 'Content Utilization',
  TITLE_SCORE: 'Title Score',
  BULLET_SCORE: 'Bullets Score',
  IMAGE_SCORE: 'Images Score',
  VIDEO_SCORE: 'Videos Score',
  APLUS_SCORE: 'Enhanced Score',
  TITLE_ACCURACY: 'Title \nAccuracy',
  BULLET_ACCURACY: 'Bullet \nAccuracy',
  IMAGE_ACCURACY: 'Image \nAccuracy',
  VIDEO_ACCURACY: 'Video \nAccuracy',
  RETAIL_SALES: 'Retail \nSales'
};
